import { render, staticRenderFns } from "./etablissement-create-dialog.vue?vue&type=template&id=58fc703e&scoped=true"
import script from "./etablissement-create-dialog.vue?vue&type=script&lang=js"
export * from "./etablissement-create-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fc703e",
  null
  
)

export default component.exports